export const PROJECT_PERSIST_REASON = {
  MANUAL_SAVE: "manual_save",
  MANUAL_TOPBAR_SAVE: "manual_topbar_save",
  NAVIGATE_HOME_BEFORE_SAVE: "navigate_home_before_save",
  SPACE_SWITCH_BEFORE_SAVE: "space_switch_before_save",
  ADD_SPACE_BEFORE_SAVE: "add_space_before_save",
  SPACE_DUPLICATE_BEFORE_SAVE: "space_duplicate_before_save",
  REVISION_AUTO_SAVE: "revision_auto_save",
} as const;

export type ProjectPersistReason =
  (typeof PROJECT_PERSIST_REASON)[keyof typeof PROJECT_PERSIST_REASON];

export type ManualProjectPersistReason =
  | typeof PROJECT_PERSIST_REASON.MANUAL_SAVE
  | typeof PROJECT_PERSIST_REASON.MANUAL_TOPBAR_SAVE;

const PROJECT_PERSIST_REASONS = new Set<string>(
  Object.values(PROJECT_PERSIST_REASON),
);

export const isProjectPersistReason = (
  reason: string,
): reason is ProjectPersistReason => PROJECT_PERSIST_REASONS.has(reason);
